import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { IonicStorageModule } from '@ionic/storage-angular';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAuth } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { authInterceptor } from './auth';
import { cleanStaleAuthWellKnownCache } from './auth/auth-storage-cleanup';
import { GlobalErrorHandler } from '@errors/global-error-handler.service';
import { fadePageTransition } from '@app/animations';
import { MESSAGE_SERVICE_TOKEN, MessageService } from '@services/messages';
import { LanguageService } from '@services/language';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: MESSAGE_SERVICE_TOKEN, useExisting: MessageService },
    provideBrowserGlobalErrorListeners(),
    provideAppInitializer(() => cleanStaleAuthWellKnownCache()),
    importProvidersFrom(IonicStorageModule.forRoot()),
    provideRouter(
      routes,
      withRouterConfig({
        canceledNavigationResolution: 'computed',
      })
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAuth({ config: environment.authConfig }),
    provideIonicAngular({
      navAnimation: fadePageTransition,
    }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'en',
    }),
    // Load and await the active language before the app renders so that
    // synchronous translate.instant() calls (page titles, grid headers, etc.)
    // resolve correctly on first paint and after a hard reload. Never block
    // bootstrap if the i18n request fails. Use the last-known language so
    // pre-login screens (e.g. auth-callback) render in the user's language.
    provideAppInitializer(() =>
      firstValueFrom(inject(TranslateService).use(inject(LanguageService).getStoredLanguage())).catch(() => undefined))
  ],
};
